import React,{useState,useEffect} from "react";
import Working from "../../Image/coding.png";
import Working1 from "../../Image/coding3.png";


import Navbar from "./Navbar";
import TextIntroduction from "./TextIntroduction";
import { ArrowSmDownIcon } from "@heroicons/react/outline";
import AboutHomePage from "../../Page/HomePage/AboutHomePage";
const Introduction = () => {
 const [arrow,setArrow] =useState()
 const [show,setShow] =useState()

 useEffect(()=>{
  setArrow(true)
 },[])
  

 const pageToShow=()=>{
  setArrow(false)
  setShow(true)
 }
  return (
  
      <div className=" items-center h-screen " id="hero">
        <div className="px-2 lg:p-4   h-screen w-full  ">
          <Navbar />
          <div className="  flex flex-col justify-center mx-auto lg:flex-row lg:mt-[50px] ">
            <TextIntroduction />
            <div className=" md:flex md:mt-0 justify-center ">
              <div className="hidden dark:block">
              <img
                src={Working}
                alt=""
                className=" w-[370px] h-[550px] md:w-[490px] lg:w-[740px] xl:mr-[290px] text-[#30dada]  "
               
              />
              </div>
              <div className="block  dark:hidden">
              <img
                src={Working1}
                alt=""
                className=" w-[370px] h-[550px] md:w-[490px] lg:w-[740px] xl:mr-[290px] text-[#30dada]  "
               
              />
              </div>
                
            </div>
          </div>
         {arrow&& <div className="mt-10 mb-[16px] md:mt-[140px] md:block lg:mt-[100px] ">
         <div className="flex justify-center  ">
          <button className="border-[4px] border-[#17A6DB] h-[44px] dark:border-[#30dada] pr-2 rounded-[50%] lg:h-[64px]" onClick={pageToShow}>
         <ArrowSmDownIcon className="  w-6 md:w-10 ml-2 text-[#17A6DB] dark:text-[#30dada]  "/></button>
         </div>
        </div>}
       {show && 
       <div className="  mt-[70px] lg:mt-[100px]">
       <AboutHomePage/>
       </div> 
       }
        </div>
       
      </div>
    
  );
};

export default Introduction;
